import { render, staticRenderFns } from "./DeletePrompt.vue?vue&type=template&id=535f184c&scoped=true"
import script from "./DeletePrompt.vue?vue&type=script&lang=js"
export * from "./DeletePrompt.vue?vue&type=script&lang=js"
import style0 from "./DeletePrompt.vue?vue&type=style&index=0&id=535f184c&prod&lang=scss&scoped=true"
import style1 from "./DeletePrompt.vue?vue&type=style&index=1&id=535f184c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f184c",
  null
  
)

export default component.exports